import { useTranslation } from 'react-i18next';

import { Collapse } from '@work4all/components/lib/components/collapse';

import { Panel } from '../../../../components/panel/Panel';

import { ChangePasswordContent } from './components/ChangePasswordContent';
import { ResetMfaContent } from './components/ResetMfaContent';

export const SecurityTabPanel = () => {
  const { t } = useTranslation();

  return (
    <Panel>
      <Collapse defaultOpen title={t('COMMON.PASSWORD')}>
        <ChangePasswordContent />
      </Collapse>

      <Collapse defaultOpen title={t('COMMON.TWO_FACTOR_AUTHORIZATION')}>
        <ResetMfaContent />
      </Collapse>
    </Panel>
  );
};
